import { schema } from 'normalizr'
import { omit } from 'ramda'

export const logicalSlotSchema = new schema.Entity(
  'slots',
  {},
  {
    idAttribute: (value) => `${value.slotName}`,
    processStrategy: (value) => ({
      ...omit(['slotName'], value),
      logicalSlot: value.slotName,
    }),
    mergeStrategy: (entityA, entityB) => {
      const input = entityA.direction === 'Input' ? entityA : entityB
      const output = entityA.direction === 'Output' ? entityA : entityB

      return {
        ...input,
        output,
      }
    },
  }
)

export const outputsSchema = new schema.Object({
  outputs: [logicalSlotSchema],
})

export const inputsSchema = new schema.Object({
  inputs: [logicalSlotSchema],
})

// TODO: remove after QA testing
// export const logicalSlotResponseSchema = new schema.Object({
//   logicalSlots: [logicalSlotSchema],
// })
export const logicalSlotResponseSchema = [logicalSlotSchema]
